/**
 * Client Industry Service
 *
 * Admin-editable replacement for the industries that used to be hardcoded
 * in src/pages/clients/ClientForm.js (#461). Mirrors projectTypeService.js
 * exactly — same table shape (code/label/sort_order/is_active), same
 * fallback-on-error behavior so the form never breaks if the table can't
 * be reached.
 *
 * @module services/clientIndustryService
 */
import { supabase } from './supabase';

const FALLBACK_INDUSTRIES = [
  { id: 'hospital', code: 'hospital', label: 'Hospital', is_active: true, sort_order: 0 },
  { id: 'clinic', code: 'clinic', label: 'Clínica', is_active: true, sort_order: 1 },
  { id: 'laboratory', code: 'laboratory', label: 'Laboratorio', is_active: true, sort_order: 2 },
  { id: 'pharmacy', code: 'pharmacy', label: 'Farmacia', is_active: true, sort_order: 3 },
  { id: 'distributor', code: 'distributor', label: 'Distribuidor', is_active: true, sort_order: 4 },
  { id: 'other', code: 'other', label: 'Otro', is_active: true, sort_order: 5 },
];

export const getClientIndustries = async (includeInactive = false) => {
  try {
    let query = supabase
      .from('client_industries')
      .select('*')
      .order('sort_order', { ascending: true })
      .order('label', { ascending: true });

    if (!includeInactive) {
      query = query.eq('is_active', true);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data?.length ? data : FALLBACK_INDUSTRIES;
  } catch {
    return FALLBACK_INDUSTRIES;
  }
};

export const createClientIndustry = async ({ code, label, sort_order = 99 }) => {
  const { data, error } = await supabase
    .from('client_industries')
    .insert({ code: code.toLowerCase().trim(), label: label.trim(), sort_order, is_active: true })
    .select()
    .single();
  return { data, error };
};

export const updateClientIndustry = async (id, updates) => {
  const patch = { ...updates };
  if (patch.code) patch.code = patch.code.toLowerCase().trim();
  if (patch.label) patch.label = patch.label.trim();

  const { data, error } = await supabase
    .from('client_industries')
    .update(patch)
    .eq('id', id)
    .select()
    .single();
  return { data, error };
};

export const deleteClientIndustry = async (id) => {
  const { error } = await supabase
    .from('client_industries')
    .delete()
    .eq('id', id);
  return { error };
};
